import { getErrorMessage } from './getErrorMessage';
import { ConfigState, initialConfigState } from '@/store/configStore/configState';
import { isObject } from '@/types/typeGuards/general';
import { config } from '@/config';
import * as Sentry from '@sentry/nextjs';

const findMissingConfigProperties = (data: Partial<ConfigState>): string[] => {
    const initialConfigStateProperties = Object.keys(initialConfigState);
    const actualConfigStateProperties = Object.keys(data);
    const missingProperties: string[] = [];
    initialConfigStateProperties.forEach((key: string) => {
        if (!actualConfigStateProperties.some((item) => item === key)) {
            missingProperties.push(key);
        }
    });
    return missingProperties;
};

let hasIncompleteConfigDataReceived = false;
export const getConfig = async (): Promise<Partial<ConfigState> | undefined> => {
    try {
        const url = `${config.api.url.config}`;
        const tags = ['config'];

        const res = await fetch(url, {
            next: { tags, revalidate: config.timeout.revalidate },
        });
        const data: unknown = await res.json();
        if (!data && !isObject(data)) {
            Sentry.captureMessage('Received invalid config data', { extra: { data } });
            return;
        }
        const missingProperties = findMissingConfigProperties(data);
        if (missingProperties.length && !hasIncompleteConfigDataReceived) {
            hasIncompleteConfigDataReceived = true;
            Sentry.captureMessage('Received incomplete config data', {
                extra: {
                    receivedData: data,
                    missingProperties,
                },
            });
        }
        return data;
    } catch (err) {
        const errorMessage = `Error getting config during build: ${getErrorMessage(err)}`;
        if (
            err &&
            isObject(err) &&
            'message' in err &&
            'name' in err &&
            err.name !== 'incorrect data'
        ) {
            err.message = errorMessage;
        }
        console.error(errorMessage);
    }
};
